import React from "react";
import PropTypes from "prop-types";
import { styled } from "@mui/material/styles";

import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import Typography from "@mui/material/Typography";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Clear";

import InlineToolbar from "~/components/InlineToolbar";

const Header = styled(DialogTitle)(() => ({
  position: "relative",
  margin: 0,
  padding: 0,
  display: "flex",
  alignItems: "center"
}));

const Title = styled(Typography)(({ theme }) => ({
  paddingLeft: theme.spacing(2),
  marginLeft: 0,
  marginRight: "auto"
}));

const Content = styled(DialogContent)(({ theme }) => ({
  padding: theme.spacing(0, 0, 2, 0),
  userSelect: "text"
}));

const StyledIconButton = styled(IconButton)(({ theme }) => ({
  "&:focus-visible": {
    outline: theme.outline(),
    outlineOffset: "-2px"
  }
}));

function MaterialInfoModal({ hideModal, title, description, kind }) {
  function renderMarkup() {
    return {
      __html: description
    };
  }

  return (
    <>
      <Header>
        <Title variant="h6" id={`${kind}-modal-title`}>
          {title}
        </Title>

        <InlineToolbar>
          <StyledIconButton onClick={hideModal} size="large" aria-label="Schließen">
            <CloseIcon />
          </StyledIconButton>
        </InlineToolbar>
      </Header>
      <DialogContent>
        {/* WARNING: Render validated and sanitized HTML only! */}
        <Content dangerouslySetInnerHTML={renderMarkup()} />
      </DialogContent>
    </>
  );
}

MaterialInfoModal.propTypes = {
  hideModal: PropTypes.func.isRequired,
  title: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  kind: PropTypes.string.isRequired
};

export default MaterialInfoModal;
